// extracted by mini-css-extract-plugin
export default {"pageContainer":"FortressWeapons_pageContainer__IUpn4"};